<template>
    <section class="comp_overview_bookings">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading" v-bind:class="{'mod--hidden':searchActive}">
                            <span>{{ $t('received_bookings') }}</span></h1>
                    </div>
                    <form class="col mod--flex-grow col--search mod--right" v-on:submit="doSearch">
                        <input ref="search" type="text" v-model="search" :placeholder="$t('search')"
                               v-bind:class="{'mod--active':searchActive}">
                        <button class="icon icon--search"></button>
                    </form>
                </header>
                <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']"
                     v-on:scroll="handleGlobalScroll($event)">
                    <template v-if="reservations.length > 0">
                        <part-booking v-for="reservation in reservations" v-bind="reservation"
                                      :key="reservation.id + '|' + reservation.row"></part-booking>
                    </template>
                    <div class="col col--12" v-else>
                        <p>{{ $t('nothing_found') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import {sanitize} from '../../main';

export default {
    name: 'overview-departures',
    data() {
        return {
            loading: false,
            count: null,
            reservations: [],
            search: '',
            searchActive: false
        }
    },
    created() {
        this.getReservations();
    },
    mounted() {

    },
    methods: {
        doSearch: function (e) {
            e.preventDefault();
            if (this.searchActive === false) {
                this.searchActive = true;
                this.$nextTick(() => this.$refs.search.focus());
            } else {
                this.getReservations();
            }
        },
        getReservations: function () {
            this.loading = true;
            let self = this;
            let data = `
                    {
                        items {
                            id
                            name
                            note
                            is_group
                            created_at
                            reservation_rows {
                                id
                                reservation_number
                                check_in_date
                                check_out_date
                                guest_count
                                total_price_per_room
                                room_type_id
                                room_count
                                room_type {
                                    code
                                }
                                price_list {
                                    accommodation_currency {
                                        code_iso
                                    }
                                }
                                guests {
                                    profile {
                                        full_name
                                    }
                                    room {
                                        code
                                    }
                                }
                                canceled
                            }
                        },
                        pageInfo {
                            totalCount
                        }
                    }
                `;

            let query = `{
                    listReservations(order_by: "id|desc", search_anywhere: "%${sanitize(this.search)}%", limit: 10)
                    ${data}
                }`;

            axios({
                data: query
            }).then(response => {
                this.count = response.data.data.listReservations.pageInfo.totalCount;

                let reservations = [];

                response.data.data.listReservations.items.forEach(function (item) {
                    item.reservation_rows.forEach(function (row) {
                        let reservation = {};
                        reservation.id = item.id;
                        reservation.row = row.id;
                        reservation.room = row.room_type.code;
                        reservation.price = row.total_price_per_room;
                        reservation.checkin_date = moment(row.check_in_date).format('D. M.');
                        reservation.checkout_date = moment(row.check_out_date).format('D. M.');
                        reservation.guest_count = row.guest_count;
                        reservation.room_count = row.room_count;
                        reservation.icons = [];
                        reservation.group = item.is_group;
                        reservation.currency = row.price_list.accommodation_currency.code_iso;
                        reservation.status = row.canceled ? 'canceled' : 'new';
                        reservation.full_name = item.name;
                        reservation.room_numbers = [];

                        if (row.guests[0] && !item.name) {
                            reservation.full_name = row.guests[0].profile.full_name;
                        }

                        if (row.guests) {
                            row.guests.forEach(function (item) {
                                if (item.room) {
                                    reservation.room_numbers.push(item.room.code);
                                }
                            });

                            reservation.room_numbers = [...new Set(reservation.room_numbers)];
                        }

                        reservations.push(reservation);
                    });
                });

                this.reservations = reservations;
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/overview-bookings.vue